import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import {
  FormControlLabel,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
  Typography
} from "@mui/material";


const Input = ({
  label,
  name,
  type,
  placeholder,
  value,
  error,
  helperText,
  onChange,
  onPaste,
  handleBlur,
  onClick,
  isEdit,
  isRequired,
  isDropdown,
  isPhone,
  isRadio,
  maxLength,
  classes,
  countryCode,
  disabled,
  rspDisable,
  disabledRSPInput,
  isDate,
  className,
  isLoading,
  inputRef,
}) => {
  const bankNumberProps =
    name === "accountNumber" ? { pattern: "[0-9]*", inputMode: "numeric" } : {};

  return (
    <>
      <Typography
        color="textPrimary"
        sx={{
          fontWeight: "700",
          fontSize: "14px",
          lineHeight: 1.57,
          marginBottom: "8px",
          color: disabled && "#9D9EA4",
        }}
      >
        {label}

        {isRequired && "*"}
      </Typography>

      {!isRadio ? (
        <TextField
          variant="outlined"
          type={type ? type : "text"}
          placeholder={placeholder}
          fullWidth
          name={name}
          value={value}
          onChange={!isDropdown ? onChange : null}
          onPaste={onPaste}
          onBlur={handleBlur && handleBlur}
          onClick={isDropdown && onClick}
          error={error}
          helperText={
            error && helperText ? helperText : error && "This field is required"
          }
          style={{ marginBottom: "14px" }}
          disabled={!isEdit || disabled}
          FormHelperTextProps={{
            style: {
              margin: "4px 0 0 0",
              color: "#be0712",
              fontFamily: "FSElliotPro",
              fontSize: "14px",
              fontWeight: "normal",
              lineHeight: 1.57,
            },
          }}
          inputRef={inputRef}
          inputProps={{
            ...bankNumberProps,
            style: {
              padding: !isPhone ? "12px 16px" : "12px 16px 12px 4px",
              backgroundColor: !isEdit && "#f6f6f8",

              color: disabledRSPInput ? "rgb(174, 174, 174)" : "#333333",
            },
            className: className,
            maxLength: maxLength, // only work for type other than number
          }}
          // eslint-disable-next-line react/jsx-no-duplicate-props
          InputProps={{
            readOnly: !isEdit || isDropdown ? true : false,
            style: {
              backgroundColor: !isEdit && "#f6f6f8",
              padding: 0,
              paddingLeft: isPhone && "16px",
            },
            startAdornment: isPhone && (
              <InputAdornment
                position="start"
                style={{ padding: 0, margin: 0 }}
              >
                <Typography
                  color="textPrimary"
                  sx={{
                    fontWeight: "700"}}
                >
                  +{countryCode ? countryCode : "60"}
                </Typography>
              </InputAdornment>
            ),
            endAdornment: isDropdown && (
              <InputAdornment
                position="end"
                style={{ padding: 0, paddingRight: "16px", margin: 0 }}
              >
                {isDate ? (
                  <CalendarTodayOutlinedIcon
                    sx={{
                      color:
                        !isEdit || disabledRSPInput ? "#C5C6C5" : "#0091DA",
                      fontSize: 18,
                    }}
                  />
                ) : isLoading ? (
                  <div className="spinner-blueish" />
                ) : (
                  <ExpandMoreOutlinedIcon
                    sx={{
                      color:
                        !isEdit || disabledRSPInput ? "#C5C6C5" : "#0091DA",
                      fontSize: 24,
                    }}
                  />
                )}
              </InputAdornment>
            ),
          }}
        />
      ) : (
        <>
          {name === "isRSPEnable" ? (
            <RadioGroup
              name={name}
              value={value}
              onChange={onChange}
              sx={{
                display: "flex",
                flexDirection: "row",
                marginBottom: "14px",
              }}
            >
              <FormControlLabel
                value="Enable"
                control={<Radio color="primary" />}
                label="Enable"
              />
              <FormControlLabel
                value="Disable"
                disabled={rspDisable}
                control={<Radio color="primary" />}
                label="Disable"
              />
            </RadioGroup>
          ) : (
            <RadioGroup
              name={name}
              value={value}
              onChange={onChange}
              sx={{
                marginBottom: "14px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <FormControlLabel
                value="No"
                control={<Radio color="primary" />}
                label="No"
              />
              <FormControlLabel
                value="Yes"
                control={<Radio color="primary" />}
                label="Yes"
              />
            </RadioGroup>
          )}
        </>
      )}
    </>
  );
};

export default Input;
